import { ReactNode } from 'react';

import { Box } from '@material-ui/core';
import moment from 'moment';

import { InfoText } from 'src/components';
import { IUsersToEvent } from 'src/services/users';
import useResponsive from 'src/utils/responsive';

import { CustomBox, CustomFormDialogBox, FORMAT_TIME } from './types';

interface IMyVolunteerDetail {
  open: boolean;
  _onCloseModal: () => void;
  event?: IUsersToEvent;
  status: ReactNode;
}
function MyVolunteerDetail({ open, _onCloseModal, event, status }: IMyVolunteerDetail) {
  const responsive = useResponsive();
  return (
    <CustomFormDialogBox
      open={open}
      _onCloseModal={_onCloseModal}
      title="Volunteer Detail"
      deleteButton
      hiddenSubmitButton
      responsive={responsive}
    >
      <CustomBox responsive={responsive}>
        <Box display="flex" justifyContent="space-between">
          <Box mr={1} flex={1}>
            <InfoText label="Event" value={event?.event.title ? event?.event.title : '-'} />
            <InfoText
              label="Time"
              value={`${moment(+event?.event.start_time!).format(FORMAT_TIME)} - ${moment(
                +event?.event.end_time!,
              ).format(FORMAT_TIME)}`}
            />
            <InfoText label="Location" value={event?.event.location ? event?.event.location : '-'} />
            <InfoText label="Registration Time" value={'-'} />
          </Box>
          <Box mr={1} flex={1}>
            <InfoText label="Status" value={status} />
            <InfoText label="Check In Time" value={moment(new Date(event?.checkinTime!)).format(FORMAT_TIME)} />
            <InfoText label="Check Out Time" value={moment(new Date(event?.checkoutTime!)).format(FORMAT_TIME)} />
          </Box>
        </Box>
      </CustomBox>
    </CustomFormDialogBox>
  );
}

export default MyVolunteerDetail;
